import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {IReelStoppedData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {SoundPlayer} from "../sound/SoundPlayer";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class BuffaloTimelineReelsController extends TimelineReelsController {

    private _gameData: WinterHoardParsedGameData;
    public quickStopped:boolean = false;


    protected addEventListeners() {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    /*stopSpin(reelId: number, data: ParsedGameData, quickStop: boolean = false, stopSpinData?: IReelStopSpinData): TimelineLite {
        this._quickStopped = quickStop;
        return super.stopSpin(reelId, data, quickStop, stopSpinData);
    }*/

    startNearWin(reelId: number, duration?: number): TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => WinterHoardGameModuleConfig.nearWinView.playOnReel(reelId, this._gameData!.scatterPositions!),
            super.startNearWin(reelId, duration)

        ]);
        return tl;//super.startNearWin(reelId, duration);
    }

    protected onReelBounceStarted(stopData: IReelStoppedData) {
        //if (!stopData.quickStop) {
            if (stopData.reelId < 4) {
                this.handleAnticipation(stopData);
            } else if(stopData.reelId === 4 && this._gameData.nearWinBigWinReels[stopData.reelId]) {
                WinterHoardGameModuleConfig.nearWinView.forcedReset();
            }

        //}

        if (stopData.reelId === 0) {
            SoundPlayer.resetScatterSoundCounter();
            WinterHoardGameModuleConfig.nearWinView.onSpinStart();
        }
        this.handleReelLandingSounds(stopData);
        if (stopData.reelId === 4) {
            this.handleLastActiveReel(stopData.reelId);
        }
        super.onReelBounceStarted(stopData);
    }

    private onGameDataParsed(data: WinterHoardParsedGameData) {
        this._gameData = data;
        this.quickStopped = false;
    }

    private handleAnticipation(stopData: IReelStoppedData): void {
        let nextReelId: number = stopData.reelId+1;
        if (this._gameData.nearWinReels[nextReelId]) {
            //if(!this.quickStopped) {
                WinterHoardGameModuleConfig.nearWinView.playOnReel(nextReelId, this._gameData!.scatterPositions!);
                SoundPlayer.playAnticipationSound(this._gameData!.mode);
            //}
        }

        if(this._gameData.nearWinBigWinReels[nextReelId] && !this._gameData.shamanspinTriggered) {
            //console.log("PLAYING BW NW ON REEL: " + nextReelId);
            //WinterHoardGameModuleConfig.nearWinView.forcedReset();
            //if(!this.quickStopped) {
                WinterHoardGameModuleConfig.nearWinView.playOnReel(nextReelId, []);
                SoundPlayer.playAnticipationSound(this._gameData!.mode);
            //}
        }
        else if(this._gameData.nearWinBigWinReels[stopData.reelId] && !this._gameData.nearWinBigWinReels[nextReelId]) {
            WinterHoardGameModuleConfig.nearWinView.forcedReset();
            SoundPlayer.stopAnticipationSound(this._gameData.singleWin > 0, this._gameData!.mode);
        }
    }

    private handleLastActiveReel(id: number): void {
        WinterHoardGameModuleConfig.nearWinView.reset(this._gameData!.scatterPositions!, this._gameData!.singleWin, true);
        if(SoundConfig.instance.REELS_SPIN_START) {
            SoundPlayer.stopEffect(SoundConfig.instance.REELS_SPIN_START[0]);
        }
        if(this._gameData.nearWinReels[id]){
            SoundPlayer.stopAnticipationSound(this._gameData!.mode == "NORMAL" && this._gameData!.nextMode.indexOf("FREESPIN")>-1, this._gameData!.mode);
        }else if(this._gameData.nearWinBigWinReels[id]){
            SoundPlayer.stopAnticipationSound(this._gameData!.isBigWin, this._gameData!.mode);
        }
    }

    stopSpin(reelId: number, data: ParsedGameData, quickStop?: boolean, stopSpinData?: IReelStopSpinData): TimelineLite {
        const tl:TimelineLite = super.stopSpin(reelId, data, quickStop, stopSpinData);
        return tl;
    }


    private handleReelLandingSounds(stopData: IReelStoppedData): void {
        if(this._gameData!.reels[stopData.reelId].indexOf("W")>0 &&(this._gameData!.reels[stopData.reelId].indexOf("W")<5)){
            SoundPlayer.playEffect(WinterHoardSoundConfig.WILD_LANDING);
        }
        if(this._gameData!.reels[stopData.reelId].indexOf("S")>0 &&(this._gameData!.reels[stopData.reelId].indexOf("S")<5)){
            SoundPlayer.playScatterSound();
        }
        SoundPlayer.playEffect(WinterHoardSoundConfig.instance.REELS_DEFAULT_BOUNCE[0]);
    }
}